import { Observable } from 'rxjs';
import { UrlTree, Router } from '@angular/router';
import { Injectable } from '@angular/core';

import { CustomerService } from '../../business-services/customer.service';

@Injectable({ providedIn: 'root' })
export class ViewCustomerGuard  {
    
    constructor(
        private service: CustomerService,
        private router: Router
    ) {}

    canActivateChild(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
        if (this.service.customerId) {
            return true;
        }
        return this.router.createUrlTree(['/customer']);
    }

}